import { useQuery } from '@tanstack/react-query'
import { query } from '../graphql'

export const useUserEndpointsQuery = ({ username }) => {
  return useQuery({
    queryKey: ['user-endpoints', username],
    queryFn: async () => {
      let response = null

      try {
        response = await query({
          query: 'pinpointControl',
          variables: { action: 'getUserEndpoints', user_id: username }
        })
      } catch (err) {
        if (err.message.toLowerCase().includes('resource not found')) {
          response = 'RESOURCE_NOT_FOUND'
        }
      }

      return response
    },
    select: (response) => {
      if (response === 'RESOURCE_NOT_FOUND') return 'RESOURCE_NOT_FOUND'

      return JSON.parse(
        response
      ).body.getUserEndpoints.res.EndpointsResponse.Item.find(
        ({ Id }) => Id === `email_${username}`
      )
    },
    enabled: !!username
  })
}
